module.exports = __webpack_public_path__ + "img/travel-agency-light.a8bbbf54.png";